import { Component } from '@poa/core';
import { observable, Observer } from '@poa/state';
import React from 'react';
import GeneralProfileSidebarContent from './components/sidebar_content';
import { GeneralAccountModal } from '../../components/account-modal/account-modal';
import { GeneralFilterModal } from '../../components/general/general-filter-modal';

import FavoriteActiveIcon from '../icons/favorite active';
import FavoriteIcon from '../icons/favorite';
import FilterIcon from '../icons/filter';

import { ACCESS_LEVEL } from '../../store/auth/auth.constants';


class GeneralSidebar extends React.Component {
    store; // injected by Poa
    actions; // injected by Poa

    localState = observable({
        search: '',
        lastPage: 1,
        filter_by: null,
        activeIdx: [],
        loadMoreCount: 0,
        isAccountModalOpened: false,
        isGeneralFilterModalOpened: false,
        selectedAccountId: null,
        showFavorite: false,
    });


    onSearchChange = async searchString => {
        if (searchString.target) {
            this.localState.search = searchString.target.value
        } else {
            this.localState.search = ''
        }
    };

    onSearchClick = async (filter_data) => {
        this.localState.lastPage = 1;

        if (filter_data) {
            this.localState.filter_by = filter_data;
        }

        await this.actions.generalProfileActions.fetchGeneralProfiles(
            this.localState.filter_by,
            this.localState.lastPage,
            this.localState.search,
            this.localState.showFavorite ? true : false,
        );

        this.localState.loadMoreCount -= 1;
    };

    handleLoadMore = async () => {

        this.localState.lastPage += 1;
        await this.actions.generalProfileActions.fetchGeneralProfiles(
            this.localState.filter_by,
            this.localState.lastPage,
            this.localState.search,
            this.localState.showFavorite ? true : false,
        );  
        
        this.localState.loadMoreCount += 1;
    };


    handleListItemClick = async (index) => {
        if (this.localState.activeIdx.includes(index)) {
            this.localState.activeIdx = this.localState.activeIdx.filter((item) => item !== index)
        } else {
            await this.actions.generalProfileActions.fetchGeneralProfileChildren(index); 
            this.localState.activeIdx = [...this.localState.activeIdx, index]
        }

        this.localState.loadMoreCount += 1;
    }

    handlChildrenListItemClick = async (index) => {
        await this.actions.generalProfileActions.fetchGeneralProfile(index); 
    }

    handleAccountModalOpen = async (accountID) => {
        this.localState.selectedAccountId = accountID;
        this.localState.isAccountModalOpened = true;
    }

    handleAccountChangeFavorite = async (index) => {

        let data = this.store.generalProfile.data;
        data = data.map(d => {
            if (d.id === index) {
                return { ...d, isFavorite: !d.isFavorite };
            }
            return d;
        });

        this.store.generalProfile.data = data;

        await this.actions.generalProfileActions.setAccountFavorite(index);
    }

    handleAccountModalClose = async () => {
        this.localState.isAccountModalOpened = false;
        this.localState.selectedAccountId = null;
    }

    handleGeneralFilterModalOpen = async () => {
        this.localState.isGeneralFilterModalOpened = true;
    }

    handleGeneralFilterModalClose = async () => {
        this.localState.isGeneralFilterModalOpened = false;
    }

    handleShowFavorite = async () => {
        this.localState.showFavorite = !this.localState.showFavorite;
        this.localState.activeIdx = [];

        await this.onSearchClick();
    }

    render() {
        return (
            <>
            <div className='general-page__container-sidebar'>
                <div className='general_sidebar-header'>
                    <div className='favorite_icon' onClick={this.handleShowFavorite}>
                        {this.localState.showFavorite ? <FavoriteActiveIcon /> : <FavoriteIcon />}
                    </div>
                    
                    <div className='general_sidebar-header__search'>
                        <div className='search__input input'>
                            <input
                                type='text'
                                placeholder='search'
                                value={this.localState.search}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter') {
                                        this.onSearchClick();
                                    }
                                }}
                                onChange={this.onSearchChange}>
                            </input>
                            <svg className='icon icon-search' onClick={this.onSearchClick} width='15px' height='15px' viewBox='0 0 15 15'
                                version='1.1' xmlns='http://www.w3.org/2000/svg'>
                                <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
                                    <g fillRule='nonzero' fill='#DBDBDB'>
                                        <path
                                            d='M14.8163265,13.9346939 L11.2102041,10.3285714 C12.1040816,9.23877551 12.6428571,7.84285714 12.6428571,6.32142857 C12.6428571,2.83163265 9.81122449,0 6.32142857,0 C2.82857143,0 0,2.83163265 0,6.32142857 C0,9.81122449 2.82857143,12.6428571 6.32142857,12.6428571 C7.84285714,12.6428571 9.23571429,12.1071429 10.3255102,11.2132653 L13.9316327,14.8163265 C14.1765306,15.0612245 14.5714286,15.0612245 14.8163265,14.8163265 C15.0612245,14.5744898 15.0612245,14.1765306 14.8163265,13.9346939 Z M6.32142857,11.3846939 C3.52653061,11.3846939 1.25510204,9.11326531 1.25510204,6.32142857 C1.25510204,3.52959184 3.52653061,1.25510204 6.32142857,1.25510204 C9.11326531,1.25510204 11.3877551,3.52959184 11.3877551,6.32142857 C11.3877551,9.11326531 9.11326531,11.3846939 6.32142857,11.3846939 Z'></path>
                                    </g>
                                </g>
                            </svg>
                        </div>
                    </div>
                    <button onClick={this.handleGeneralFilterModalOpen}>
                        <FilterIcon />
                        Filter
                    </button>
                </div>
                <GeneralProfileSidebarContent
                    data={this.store.generalProfile.data}
                    activeIdx={this.localState.activeIdx}
                    handleListItemClick={this.handleListItemClick}
                    handlChildrenListItemClick={this.handlChildrenListItemClick}
                    handleLoadMore={this.handleLoadMore}
                    loadMoreCount={this.localState.loadMoreCount}
                    loadMoreIsVisible={this.store.generalProfile.meta.currentPage < this.store.generalProfile.meta.pages}
                    handleAccountModalOpen={this.handleAccountModalOpen}
                    changeFavorite={this.handleAccountChangeFavorite}
                    isAccountModalVisible={this.store.auth.accessLevel !== ACCESS_LEVEL.operator}
                />
            </div>

            <Observer>
                {() => (
                    <GeneralAccountModal
                        isOpened={this.localState.isAccountModalOpened}
                        requestClose={this.handleAccountModalClose}
                        accountId={this.localState.selectedAccountId}
                    />
                )}
            </Observer>

            <Observer>
                {() => (
                    <GeneralFilterModal
                        isOpened={this.localState.isGeneralFilterModalOpened}
                        requestClose={this.handleGeneralFilterModalClose}
                        handleShowFavorite={this.handleShowFavorite}
                        showFavorite={this.localState.showFavorite}
                        onSearchChange={this.onSearchChange}
                        onSearchClick={this.onSearchClick}
                        searchString={this.localState.search}
                    />
                )}
            </Observer>

            </>
        );
    }
}

export default Component({ namespaces: ['general-sidebar'] })(GeneralSidebar);
